export class ApplicationSearchConstants {
    static FORM_CONTROLS = {
        nameLabel: "Name",
        surnameLabel: "Surname",
        contactNameLabel: "Contact Name",
        contactSurnameLabel: "Contact Surname",
        organisationLabel: "Organisation",
        dateOfBirthLabel: "Date of Birth",
        assignedToLabel: "Assigned to",
        buildingUseLabel: "Building use",
        unassignedApplicationLabel: "Unassigned application",
        townplannerLabel: "Townplanner",
        transferAttorneyLabel: "Transfer Attorney",
        idNumberLabel: "ID Number",
        dateOfDeathLabel: "Date of death",
        fromDateLabel: "Select 'from' date",
        toDateLabel: "Select 'to' date",
        beforeDateLabel: "Date of deed transfer before",
        afterDateLabel: "Date of deed transfer after",
        percentCompleteLabel: "Percentage complete",
        statusLabel: "Application status",
        erfNoLabel: "Erf No.",
        farmNoLabel: "Farm No.",
        allotmentLabel: "Allotment",
        sgCodeLabel: "SG Code",
        timeoutStatusLabel: "Timeout status",
        businessUseLabel: "Business use",
        applicationTypeLabel: "Application types",
        daysUntilExpiredLabel: "Days until expired",
        categoryLabel: "Category",
        dateLabel: "Select date",
        datePlaceholder: "yyyy/mm/dd",
        endDateLabel: "Lease end date",
        startDateLabel: "Lease start date",
        searchText: "Search",
        premiseIdLabel: "Premise id",
        accountNumberLabel: "Account number",
        implementationDateLabel: "Implementation date",
        valuationRunLabel: "Valuation run",
        implementationStartDateLabel: "Implementation start date",
        implementationEndDateLabel: "Implementation end date",
        cancelBtnPlaceholder: "Cancel",
        assignedToUsersForm: "assignedToUsersForm",
        applicantAgentForm: "applicantAgentForm",
        nameFormControl: "nameFormControl",
        surnameFormControl: "surnameFormControl",
        idNumberFormControl: "idNumberFormControl",
        organisationFormControl: "organisationFormControl",
        erfNoFormControl: "erfNoFormControl",
        farmNoFormControl: "farmNoFormControl",
        allotmentFormControl: "allotmentFormControl",
        sgCodeFormControl: "sgCodeFormControl",
        assignedToUsersFormControl: "assignedToUsersFormControl",
        buildingUseFormControl: "buildingUseFormControl",
        createdDateFormControl: "createdDateFormControl",
        startDateFormControl: "startDateFormControl",
        toCreatedDateFormControl: "toCreatedDateFormControl",
        toStartDateFormControl: "toStartDateFormControl",
        fromCreatedDateFormControl: "fromCreatedDateFormControl",
        fromStartDateFormControl: "fromStartDateFormControl",
        dateOfDeathFormControl: "dateOfDeathFormControl",
        statusFormControl: "statusFormControl",
        categoryFormControl: "category",
        daysUntilExpiredFormControl: "daysUntilExpiredFormControl",
        applicationTypeFormControl: "applicationTypeFormControl",
        townPlannerFormControl: "townPlannerFormControl",
        groupNameFormControl: "groupNameFormControl",
        deedTransferBeforeDateFormControl: "deedTransferBeforeDateFormControl",
        deedTransferAfterDateFormControl: "deedTransferAfterDateFormControl",
        deedTransferDateFormControl: "deedTransferDateFormControl",
        leaseContractDateFormControl: "leaseContractDateFormControl",
        leaseEndDateFormControl: "leaseEndDateFormControl",
        leaseStartDateFormControl: "leaseStartDateFormControl",
        premiseIdFormControl: "premiseIdFormControl",
        accountNumberFormControl: "accountNumberFormControl",
        valuationRunFormControl: "valuationRunFormControl",
        implementationDateFormControl: "implementationDateFormControl",
        implementationEndDateFormControl: "implementationEndDateFormControl",
        implementationStartDateFormControl: "implementationStartDateFormControl"
    };
    static APP_SEARCH_EXPAND_FULL_LIST_A = "lastEditedUser,createdSystemUser,applicant,status,timeouts,applicantAgent";
    static APP_SEARCH_EXPAND_FULL_LIST_TM = "lastEditedUser,createdSystemUser,applicant,status,timeouts,applicantAgent,properties($expand=owners)";
    static APP_SEARCH_EXPAND_FULL_LIST_EC = "lastEditedUser,createdSystemUser,applicant,status,timeouts,applicantAgent,properties($expand=owners)";
    static APP_SEARCH_EXPAND_FULL_LIST_ZC = "lastEditedUser,createdSystemUser,applicant,status,timeouts,applicantAgent,properties($expand=owners)";
    static APP_SEARCH_EXPAND_FULL_LIST_DM = "lastEditedUser,createdSystemUser,applicant,status,timeouts,applicantAgent,properties($expand=owners)";
    static APP_SEARCH_EXPAND_FULL_LIST_IT = "lastEditedUser,createdSystemUser,applicant,status,timeouts,applicantAgent,bays,tradeGoods";
    static APP_SEARCH_EXPAND_FULL_LIST_TP = "lastEditedUser,createdSystemUser,applicant,status,timeouts,applicationTypes,applicantAgent,properties($expand=owners,zonings),applicationZonings";
    static APP_SEARCH_EXPAND_FULL_LIST_GT = "lastEditedUser,createdSystemUser,applicant,status,timeouts,applicationTypes,applicantAgent,properties($expand=owners,zonings)";
    static APP_SEARCH_EXPAND_LIST_CM = "lastEditedUser,deceased($expand=deceasedNames),createdSystemUser,applicant,status,applicantAgent";
    static APP_SEARCH_EXPAND_FULL_LIST_CM = "lastEditedUser,deceased($expand=deceasedNames),createdSystemUser,applicant,status,timeouts,applicantAgent,funeralParlour,family,graves";
    static APP_SEARCH_EXPAND_FULL_LIST_W = "lastEditedUser,createdSystemUser,applicant,status,timeouts,applicantAgent";
    static APP_SEARCH_EXPAND_FULL_LIST_MND = "lastEditedUser,createdSystemUser,status,timeouts";
    static APP_SEARCH_EXPAND_FULL_LIST_BP = "lastEditedUser,createdSystemUser,applicant,status,timeouts,applicantAgent,properties($expand=zonings,buildings,owners)";
    static APP_SEARCH_EXPAND_FULL_LIST_BPI = "lastEditedUser,createdSystemUser,applicant,status,timeouts,applicantAgent,properties($expand=owners)";
    static APP_SEARCH_EXPAND_LIST_PL = "lastEditedUser,createdSystemUser,applicant,status,timeouts,applicantAgent";
    static APP_SEARCH_EXPAND_FULL_LIST_PL = "lastEditedUser,createdSystemUser,applicant,status,timeouts,applicantAgent,buyers,sellers,lessees,transferAttorney,properties($expand=owners)";
    static APP_SEARCH_EXPAND_FULL_LIST_PV = "lastEditedUser,createdSystemUser,status,timeouts,municipalValuer,valuationRoll($expand=projectCycle)"; // TODO PV FILL IN
    static APP_SEARCH_EXPAND_LIST_EH = "lastEditedUser,createdSystemUser,applicant,status,timeouts";
    static APP_SEARCH_EXPAND_FULL_LIST_RC = "lastEditedUser,createdSystemUser,applicant,status,timeouts,applicantAgent,properties($expand=managingAgent)";
    static APP_SEARCH_EXPAND_FULL_LIST_BL = "lastEditedUser,createdSystemUser,businessOwner,applicant,status,timeouts,applicantAgent,properties";
    static APP_SEARCH_EXPAND_FULL_LIST_EH = "lastEditedUser,createdSystemUser,applicant, status"; // ,timeouts"; // TODO EH FILL IN
    static APP_SEARCH_EXPAND_FULL_LIST_SN = "lastEditedUser,createdSystemUser,applicant,status,timeouts,applicantAgent";
    static APPLICATION_AGENT = "applicantAgent";
    static FUNERAL_PARLOUR = "funeralParlour";
    static FAMILY = "family";
    static ORGANISATION = "organisation";
    static APPLICANT = "applicant";
    static STATUS = "status";
    static CATEGORY = "category";
    static NAME = "name";
    static SURNAME = "surname";
    static USER_ID = "userId";
    static MODULE_ID = "moduleId";
    static USER = "user";
    static LAST_NAME = "lastName";
    static FIRST_NAME = "firstName";
    static CREATED_DATE = "createdDate";
    static DEFAULT_SEARCH = "referenceNumber";
    static PERCENT_COMPLETE = "percentageComplete";
    static APPLICATION_JOB_LINK = "applicationJobLink";
    static WORKFLOW_SECTION = "WorkflowSection";
    static DAYS_UNTIL_EXPIRED = "daysUntilExpired";
    static TIMEOUT_STATUS = "timeoutStatus";
    static BUILDING_USE = "buildingUse";
    static APPLICATION_TYPES = "applicationTypes";
    static APPLICATION_TYPE = "applicationType";
    static OWNERS = "owners";
    static PROPERTIES = "properties";
    static PROPERTY_BUILDINGS = "propertybuildings";
    static PROPERTY_ZONINGS = "propertyzonings";
    static ZONINGS = "zonings";
    static BUILDINGS = "buildings";
    static TOWNPLANNER_ID = "TownplannerId";
    static DECEASED = "deceased";
    static DECEASED_NAMES = "deceasedNames";
    static BURIAL_ORDER_NUMBER = "burialOrderNumber";
    static ASSIGNED_TO = "assignedTo";
    static ID_NUMBER = "idNumber";
    static DATE_OF_BIRTH = "dateOfBirth";
    static DATE_OF_DEATH = "dateOfDeath";
    static OPTION_SELECT_GRAVE = "Search burial applications with grave";
    static GRAVES = "graves";
    static ERF_NUMBER = "erfNumber";
    static FARM_NUMBER = "farmNumber";
    static ALLOTMENT = "allotment";
    static SG_CODE = "sgCode";
    static SEARCH_BY_SHAPE = "SearchByShape";
    static TRANSFER_ATTORNEY = "transferAttorney";
    static BUYERS = "buyers";
    static SELLERS = "sellers";
    static LESSEES = "lessees";
    static DATE_DEED_TRANSFER = "dateOfDeedTransfer";
    static LEASE_START_DATE = "leaseStartDate";
    static LEASE_END_DATE = "leaseEndDate";
    static WITH_GRAVE = "withGrave";
    static DATE_IMPLEMENTATION = "implementationDate";
    static VALUATION_RUN_ID = "projectCycleId";
    static ORGANISATION_REQUIRED_ERROR_MESSAGE = "Organisation is required.";
    static START_DATE = "startDate";
}
